import { TrashIcon } from "@heroicons/react/outline";
import { useContext } from "react";

import { DatasetEditorContext } from "../..";

import { useAuth } from "@/context/auth-context";
import { useDeleteDatasetRows, EntityType } from "@/queries";
import { DropdownMenuVariant } from "@/components/ui/DropdownMenu/types";
import { useRbac } from "@/providers/RbacProvider";

export const useDeleteAllRows = () => {
  const authContext = useAuth();
  const { userToken } = authContext!;
  const context = useContext(DatasetEditorContext);
  const deleteAllRows = useDeleteDatasetRows(
    userToken!,
    context?.setProcessingType ?? (() => undefined),
  );

  const { isEditDisabled } = useRbac();
  const cannotEditDataset = isEditDisabled(EntityType.DATASET);

  return {
    id: "delete-all-rows",
    label: "Delete All Rows",
    icon: TrashIcon,
    onClick: () => deleteAllRows.mutate(),
    tooltipContent: cannotEditDataset
      ? "You don't have permission to delete all rows from this dataset"
      : undefined,
    getDisabled: () =>
      cannotEditDataset ||
      context?.isDeletingDataset ||
      context?.isDeletingDatasetGroup ||
      context?.isRowsEmpty ||
      !context?.isDraft,
    shouldShow: context?.isDraft,
    variant: DropdownMenuVariant.DESTRUCTIVE,
    isLoading: deleteAllRows.isLoading,
  };
};
